import "@/utils/safe-area";
import { AppProvider } from "@/providers/AppProvider";
import { routes } from "@/routes";
import * as Sentry from "@sentry/react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter(routes);

function App() {
  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
}

export default Sentry.withProfiler(App);
